export const formatPhone = (input: string, dash?: boolean) => {
	let cleaned = input.replace(/^0+/, '')
	if (dash) {
		const blocks = []
		cleaned = cleaned.replace(/-/g, '')
		for (let i = 0; i < cleaned.length; i += 4) {
			blocks.push(cleaned.slice(i, i + 4))
		}
		return '+62 ' + blocks.join('-')
	} else {
		const fullNumber = '62' + cleaned
		return fullNumber
	}
}
